import React, { useState, useEffect } from 'react';

const CookieConsent = () => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const cookieAccepted = localStorage.getItem('cookieAccepted');
    if (!cookieAccepted) {
      setIsVisible(true);
    }
  }, []);

  const handleAccept = () => {
    localStorage.setItem('cookieAccepted', 'true');
    document.cookie = "cookiesAccepted=true; max-age=" + 60*60*24*365;
    setIsVisible(false);
  };

  const handleDecline = () => {
    localStorage.setItem('cookieAccepted', 'false');
    document.cookie = "cookiesAccepted=false; max-age=" + 60*60*24*30;
    setIsVisible(false);
  };

  if (!isVisible) return null;

  const styles = {
    container: {
      position: 'fixed',
      bottom: '20px',
      left: '20px',
      right: '20px',
      maxWidth: '1200px',
      margin: '0 auto',
      zIndex: 1000,
      animation: 'slideUp 0.5s ease-out',
    },
    content: {
      background: '#1a1a1a',
      backdropFilter: 'blur(10px)',
      borderRadius: '16px',
      padding: '20px 30px',
      boxShadow: '0 20px 40px rgba(0, 0, 0, 0.2)',
      display: 'flex',
      alignItems: 'center',
      gap: '20px',
      border: '1px solid #333',
      flexWrap: 'wrap',
    },
    icon: {
      fontSize: '32px',
      background: '#2a2a2a',
      width: '50px',
      height: '50px',
      borderRadius: '12px',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
    },
    textContainer: {
      flex: 1,
      minWidth: '250px',
    },
    title: {
      margin: 0,
      fontSize: '16px',
      fontWeight: '600',
      color: '#fff',
      marginBottom: '4px',
    },
    description: {
      margin: 0,
      fontSize: '14px',
      color: '#999',
      lineHeight: '1.5',
    },
    link: {
      color: '#6c5ce7',
      textDecoration: 'none',
      marginLeft: '4px',
    },
    buttonContainer: {
      display: 'flex',
      gap: '12px',
    },
    declineBtn: {
      padding: '10px 24px',
      borderRadius: '30px',
      border: '1px solid #333',
      background: 'transparent',
      color: '#fff',
      fontSize: '14px',
      fontWeight: '500',
      cursor: 'pointer',
      transition: 'all 0.2s',
    },
    acceptBtn: {
      padding: '10px 24px',
      borderRadius: '30px',
      border: 'none',
      background: '#6c5ce7',
      color: '#fff',
      fontSize: '14px',
      fontWeight: '500',
      cursor: 'pointer',
      transition: 'all 0.2s',
    },
  };

  // Add keyframes animation
  const styleSheet = document.createElement("style");
  styleSheet.textContent = `
    @keyframes slideUp {
      from {
        transform: translateY(100%);
        opacity: 0;
      }
      to {
        transform: translateY(0);
        opacity: 1;
      }
    }
  `;
  document.head.appendChild(styleSheet);

  return (
    <div style={styles.container}>
      <div style={styles.content}>
        <div style={styles.icon}>🍪</div>
        
        <div style={styles.textContainer}>
          <h3 style={styles.title}>Cookies & Privacy</h3>
          <p style={styles.description}>
            We use cookies to enhance your experience. By continuing to visit this site, 
            you agree to our use of cookies.
            <a href="/privacy-policy" style={styles.link}> Learn more</a>
          </p>
        </div>

        <div style={styles.buttonContainer}>
          <button 
            onClick={handleDecline} 
            style={styles.declineBtn}
            onMouseOver={(e) => e.target.style.background = '#2a2a2a'}
            onMouseOut={(e) => e.target.style.background = 'transparent'}
          >
            Decline
          </button>
          <button 
            onClick={handleAccept} 
            style={styles.acceptBtn}
            onMouseOver={(e) => e.target.style.background = '#5b4bc4'}
            onMouseOut={(e) => e.target.style.background = '#6c5ce7'}
          >
            Accept All
          </button>
        </div>
      </div>
    </div>
  );
};

export default CookieConsent;